import React from 'react';
import styled from 'styled-components';
import type { DefaultTheme } from 'styled-components';
import { FjInput, FjTypeahead } from 'components/primitives';

// TODO: move size constants/logic to fj-primitives
export const inputSizes = {
  SM: 'SM',
  MD: 'MD',
  LG: 'LG',
} as const;

interface GetWidthProps {
  theme: DefaultTheme;
  size?: unknown;
}

const getWidth = (props: GetWidthProps): string => {
  const {
    theme: {
      grid: { units },
    },
    size,
  } = props;
  const sizes: Record<string, string> = {
    [inputSizes.SM]: units(2.5),
    [inputSizes.MD]: units(5),
    [inputSizes.LG]: units(15),
  };
  return sizes[size as string] || size ? units(size as number) : 'auto';
};

interface InputWrapperProps {
  typeahead?: boolean;
  size?: unknown;
  [key: string]: unknown;
}

// LibraryManagedAttributes (not plain ComponentProps) reflects what `defaultProps`
// already makes optional for JSX callers — the same relaxation a real
// `<FjInput other-props />` element gets, so no `unknown` bridge is needed here.
type FjInputCallerProps = React.JSX.LibraryManagedAttributes<
  typeof FjInput,
  React.ComponentProps<typeof FjInput>
>;
type FjTypeaheadCallerProps = React.JSX.LibraryManagedAttributes<
  typeof FjTypeahead,
  React.ComponentProps<typeof FjTypeahead>
>;

const InputWrapper = ({ typeahead, ...props }: InputWrapperProps) =>
  typeahead ? (
    <FjTypeahead {...(props as FjTypeaheadCallerProps)} />
  ) : (
    <FjInput {...(props as FjInputCallerProps)} />
  );

const Input = styled(InputWrapper).attrs(({ theme }) => ({
  fontSize: theme.fontSizes.p,
  fixedError: true,
}))`
  flex: 1;
  font-size: ${({ theme }) => theme.fontSizes.p};
  border-width: 0.5px;
  width: ${getWidth};
  input {
    height: ${({ theme: { grid } }) => grid.units(1.5)};
    border-color: ${({ theme }) => theme.colors.selectableLightBg};
    padding: 5px 10px;
  }
`;

export default Input;
